export const packetsFromServerToClient = [
  {
    id: 10,
    path: [
      "195.113.76.22",
      "2002:c0a8:101::1",
      "57.200.0.1",
      "82.208.6.9",
      "208.67.222.222",
      "222.173.190.239",
      "195.113.27.221",
    ],
    content: "",
    from: "195.113.76.22",
    to: "195.113.27.221",
    speed: 40,
  },
  {
    id: 11,
    path: [
      "195.113.76.22",
      "2002:c0a8:101::1",
      "208.67.222.222",
      "57.200.0.1",
      "2002:c0a8:101::1",
      "222.173.190.239",
      "195.113.27.221",
    ],
    content: "",
    from: "195.113.76.22",
    to: "195.113.27.221",
    speed: 40,
  },
  {
    id: 12,
    path: [
      "195.113.76.22",
      "2002:c0a8:101::1",
      "57.200.0.1",
      "208.67.222.222",
      "2002:c0a8:101::1",
      "222.173.190.239",
      "195.113.27.221",
    ],
    content: "",
    from: "195.113.76.22",
    to: "195.113.27.221",
    speed: 40,
  },
];
